import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import HeroSection from './components/HeroSection';
import InteractiveWorldMap from './components/InteractiveWorldMap';
import SupplierDirectory from './components/SupplierDirectory';
import MarketIntelligence from './components/MarketIntelligence';
import TradeFacilitation from './components/TradeFacilitation';
import PartnershipOpportunities from './components/PartnershipOpportunities';

const GlobalTradeNetwork = () => {
  return (
    <>
      <Helmet>
        <title>Global Trade Network - InChi Solutions Hub</title>
        <meta
          name="description"
          content="Access 2,500+ verified international suppliers across 45+ countries. Real-time market intelligence, trade facilitation services, and comprehensive partnership opportunities for global commerce."
        />
        <meta
          name="keywords"
          content="global trade, international suppliers, trade network, market intelligence, trade facilitation, supplier directory, partnership opportunities, import export"
        />
      </Helmet>

      <div className="min-h-screen flex flex-col bg-background">
        <Header />

        <main className="flex-1 pt-16">
          <HeroSection />
          <InteractiveWorldMap />
          <SupplierDirectory />
          <MarketIntelligence />
          <TradeFacilitation />
          <PartnershipOpportunities />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default GlobalTradeNetwork;